import path, { createRouteObject } from 'Router/path'
import component from 'Components/index'
import { RouteRecordRaw } from 'vue-router';

const router: RouteRecordRaw[] = [
    createRouteObject({
        path: path.productList,
        component: component.ProductLandingPage
    }),
    createRouteObject({
        path: path.productForm,
        component: component.ProductFormPage
    }),
]

export default router;